import React from "react";

import '@fullcalendar/core';

import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import momentPlugin from '@fullcalendar/moment';
import timeGridPlugin from '@fullcalendar/timegrid';

import FullCalendar from '@fullcalendar/react';

import "bootstrap-icons/font/bootstrap-icons.css";
import { IEvent } from "./EventCalendar";

interface CalendarConfigProps {
  calendarRef: React.RefObject<any>;
  events: IEvent[];
  initialView: string;
  initialDate: Date;
  updateEventAllowed: boolean;
  newEventAllowed: boolean;
  shouldShowAddEventButton: boolean;
  onEventClick: (info: any) => void;
  onSelect: (selectionInfo: any) => void;
  onEventChange: (info: any) => void;
  onDatesSet: (info: any) => void;
  onGoToDateButton: () => void;
  onAddEventButton: () => void;
  updateEvents: () => void;
}

export const CalendarConfig: React.FC<CalendarConfigProps> = ({
  calendarRef,
  events,
  initialView,
  initialDate,
  updateEventAllowed,
  newEventAllowed,
  shouldShowAddEventButton,
  onEventClick,
  onSelect,
  onEventChange,
  onDatesSet,
  onGoToDateButton,
  onAddEventButton,
  updateEvents,
}) => {
  const eventContent = (eventInfo: any) => {
    if (eventInfo.view.type === "listMonth") {
      return (
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <div className="calendar-identity-column">
            {eventInfo.event.extendedProps.identityName}
          </div>
          <div>{eventInfo.timeText}</div>
          <b>{eventInfo.event.title}</b>
        </div>
      );
    }
  };

  return (
    <FullCalendar
      plugins={[
        dayGridPlugin,
        bootstrap5Plugin,
        timeGridPlugin,
        interactionPlugin,
        listPlugin,
        momentPlugin,
      ]}
      ref={calendarRef}
      height={"80vh"}
      initialView={initialView}
      initialDate={initialDate}
      themeSystem="bootstrap5"
      fixedWeekCount={false}
      customButtons={{
        goToDateButton: {
          text: "Go to date",
          click: onGoToDateButton,
        },
        addEventButton: {
          text: "New Diary Entry",
          click: onAddEventButton,
        },
      }}
      locale="en-GB"
      headerToolbar={{
        start: (initialView === "" ? "dayGridMonth,timeGridWeek,timeGridDay,listMonth " : "") + "today goToDateButton prevYear,prev,next,nextYear",
        center: "title",
        end: shouldShowAddEventButton ? "addEventButton" : "",
      }}
      buttonText={{
        today: "Today",
        month: "Month",
        week: "Week",
        day: "Day",
        list: "List",
      }}
      businessHours={{
        daysOfWeek: [1, 2, 3, 4, 5],
        startTime: "08:00",
        endTime: "18:00",
      }}
      eventSources={[
        {
          events: events,
          id: "main",
        },
      ]}
      editable={updateEventAllowed}
      eventClick={onEventClick}
      selectable={newEventAllowed}
      select={onSelect}
      eventChange={onEventChange}
      datesSet={onDatesSet}
      eventContent={eventContent}
    />
  );
};
